<template>
  <section>
    <v-container>
      <div style="height: 50px"></div>
      <v-row dense>
        <v-col>
          <v-select
            :items="sensores"
            v-model="sensorSeleccionado"
            label="Sensor"
            @change="actualizarGrafica()"
          ></v-select>
        </v-col>
        <v-col>
          <v-select
            prepend-icon="mdi-calendar"
            :items="rango"
            v-model="rangoSeleccionado"
            label="Rango de fechas/horas"
            @change="actualizarGrafica()"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-select
          prepend-icon="mdi-chart-line"
          class="mx-1"
          :items="tiposGrafica"
          v-model="tipoGraficaSeleccionado"
          label="Tipo de gráfica"
          @change="actualizarGrafica()"
        ></v-select>
      </v-row>
    </v-container>

    <div class="chart">
      <!-- <label class="v-label theme--dark ml-10">Temperatura °C</label> -->
      <div v-show="sensorSeleccionado" class="mt-n10" style="width: 107%; height: 97%">
        <LineChart
          :data="seriesGrafica"
          zoom
          smooth
          :legend="false"
          :colors="colores"
        />
      </div>
    </div>
  </section>
</template>

<script>
import api from "@/api";
import { LineChart } from "dr-vue-echarts";
import { DateTime } from "luxon";

export default {
  name: "Historico",
  components: { LineChart },
  data: () => ({
    sensores: [],
    sensorSeleccionado: null,
    tiposGrafica: [
    {
      value: 0,
      text: "Temperatura (°C) y Humedad relativa (%)"
    },
    {
      value: 1,
      text: "Temperatura (°C)"
    },
    {
      value: 2,
      text: "Humedad relativa (%)"
    }
    ],
    tipoGraficaSeleccionado: 0,
    rango: [ {
      value: 24,
      text: "Últimas 24h"
    },
    {
      value: 48,
      text: "Últimas 48h"
    },
    {
      value: 72,
      text: "Últimas 72h"
    },
    {
      value: 168,
      text: "Últimos 7 días"
    },
    {
      value: 360,
      text: "Últimos 15 días"
    },
    {
      value: 720,
      text: "Últimos 30 días"
    }],
    rangoSeleccionado: 48,
    seriesGrafica: [],
    colores: [],
  }),

  methods: {
    atras() {
      this.$router.back();
    },
    actualizarGrafica() {
      this.$global.cargando = true;

      // memorizamos preferencias
      localStorage.setItem ('historico.sensor', this.sensorSeleccionado);
      localStorage.setItem ('historico.rango', this.rangoSeleccionado);

      // preparamos la consulta
      let hasta = DateTime.local();
      let desde = hasta.minus ({ hours: this.rangoSeleccionado });
      // realizamos la peticion al servidor
      api
        .historico(this.sensorSeleccionado, desde.toISO({ includeOffset: false }), hasta.toISO({ includeOffset: false }))
        .then((respuesta) => {
          let arrayTemperaturas = [];
          let arrayHumedades = [];
          for (var i = 0; i < respuesta.data.fechasHoras.length; i++) {
            let registro = {};
            registro.label = DateTime.fromISO(
              respuesta.data.fechasHoras[i]
            ).toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY);
            registro.value = respuesta.data.temperaturas[i];
            arrayTemperaturas.push({...registro});
            registro.value = respuesta.data.humedades[i];
            arrayHumedades.push({...registro});
          }

          this.seriesGrafica = [];
          this.colores = [];
          if ([0, 1].includes (this.tipoGraficaSeleccionado)) {
            this.seriesGrafica.push ( { name: "Temperatura °C", data: arrayTemperaturas } );
            this.colores.push ('#ff4040');
          }
          if ([0, 2].includes (this.tipoGraficaSeleccionado)) {
            this.seriesGrafica.push ( { name: "Humedad relativa %", data: arrayHumedades } );
            this.colores.push ('#42a5f5');
          }
        })
        .finally(() => {
          this.$global.cargando = false;
        });
    },
  },

  mounted() {
    this.$global.cargando = true;
    api
      .estadoSensores()
      .then ((respuesta) => {
        if (respuesta.data.sensores.length == 0) {
          this.$global.cargando = false;
          return;
        }

        respuesta.data.sensores.forEach((e) => {
          this.sensores.push({ text: e.descripcion, value: e.idSensor });
        });

        if (this.sensores.length > 0) {
          // establecemos el sensor a seleccionar inicialmente
          if (this.$route.query.idSensor)
            this.sensorSeleccionado = this.$route.query.idSensor;
          else if (localStorage.getItem ('historico.sensor') != null)
            this.sensorSeleccionado = localStorage.getItem ('historico.sensor');

          // si no encontramos el sensor, seleccionamos el primero de la lista
          if (!this.sensores.some ((obj) => obj.value == this.sensorSeleccionado))
            this.sensorSeleccionado = this.sensores[0].value;

          if (localStorage.getItem ('historico.rango') != null)
            this.rangoSeleccionado = parseInt (localStorage.getItem ('historico.rango'));
          if (!this.rango.some ((obj) => obj.value == this.rangoSeleccionado))
            this.rangoSeleccionado = 48;

          this.actualizarGrafica();
        }
      })
      .finally(() => {
        // OJO! el indicador de "cargando..." se desactivará si todo va bien en "actualizarGrafica()"
      });
  },
};
</script>

<style scoped>
.chart {
  margin: auto;
  width: 97%;
  height: 70vh;
  height: calc(100vh - 213px);
}
</style>